import { component, factory } from 'tsdi';

@component
export class LocationFactory {
    @factory({ name: 'Location' })
    public getLocation(): Location {
        return location;
    }
}
